import { useMemo } from 'react'
import { ProgressIndicator } from '@/components/atoms'
import { Setup, Display, Review } from '@/containers/ClubPlus/CreateTier/phases'
import './createTierContainer.scss'
import { useIntl } from 'react-intl'

const PHASES = [Setup, Display, Review]

export const CreateTierContainer = ({ setPhase, phase }) => {
  const { formatMessage } = useIntl()

  const CurrentPhase = useMemo(() => {
    return PHASES[phase - 1] || PHASES[0]
  }, [phase])

  const titles = useMemo(() => [
    { title: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_SETUP_TITLE' }) },
    { title: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_DISPLAY_TITLE' }) },
    { title: formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_REVIEW_TITLE' }) }
  ], [formatMessage])

  return (
    <>
      <ProgressIndicator
        currentStep={phase}
        completed={false}
        orientation="horizontal"
        steps={3}
        titles={titles}
        className="mb-6 mt-8"
      />
      <CurrentPhase key={phase} setPhase={setPhase} />
    </>
  )
}
